import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import StoreTitle from "../../component/StoreTitle";
import axios from "axios";
import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: "aes" });


const ReceiptHero = () => {
  const navigate = useNavigate();
  const [toggles, setToggles] = useState({});

  useEffect(() => {
    const fetchToggles = async () => {
      try {
        const token = ls.get("authToken");
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/v1/api/pos/toggles`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setToggles(res.data);
      } catch (err) {
        console.error("Failed to fetch toggles", err);
      }
    };

    fetchToggles();
  }, []);

  return (
    <Box sx={{ padding: 3 }}>
      <Button
        variant="contained"
        color="primary"
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate("/dashboard")}
        sx={{ marginBottom: 3 }}
      >
        Back
      </Button>

      <Box sx={{ marginTop: -8 }}>
        <StoreTitle title="Configuration" />
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          marginBottom: 4,
          gap: 2,
        }}
      >
        <Button variant="outlined" onClick={() => navigate("/config")}>
          Configure Receipt
        </Button>
        {toggles["service charge"] && (
          <Button variant="outlined" onClick={() => navigate("/config-service-charge")}>
            Service Charge
          </Button>
        )}
       {(toggles["foh gross sales"] || toggles["boh gross sales"]) && (
          <Button variant="outlined" onClick={() => navigate("/config-gross-sales")}>
           Sales Goal
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default ReceiptHero;
